module.exports = __webpack_public_path__ + "nl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/nl.svg
// module id = 989
// module chunks = 0